import { DROPAREA_PADDING, DropAreaWithPadding, StyledDropArea } from "@components/fileUploader";
import { StyledToolbar } from "@components/toolbar/Toolbar.styles";
import styled from "styled-components";

import View from "../View";

export const FileViewStyled = styled(View)`
    ${StyledDropArea} {
        ${DropAreaWithPadding};
        margin-top: ${DROPAREA_PADDING}px;
    }
    
    ${StyledToolbar} {
        margin-top: 17px;
    }
}`;